import axios from 'axios';
import {
  EVENTS_LOAD_EVENTS_BEGIN,
  EVENTS_LOAD_EVENTS_SUCCESS,
  EVENTS_LOAD_EVENTS_FAILURE,
  EVENTS_LOAD_EVENTS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadEvents(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EVENTS_LOAD_EVENTS_BEGIN,
    });
    const { projectId, page, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events`;
      if (page || page === 0) {
        url += `?limit=${10}&&page=${page}`;
      }
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: EVENTS_LOAD_EVENTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EVENTS_LOAD_EVENTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadEventsError() {
  return {
    type: EVENTS_LOAD_EVENTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_LOAD_EVENTS_BEGIN:
      return {
        ...state,
        loadEventsPending: true,
        loadEventsError: null,
      };

    case EVENTS_LOAD_EVENTS_SUCCESS:
      return {
        ...state,
        loadEventsPending: false,
        loadEventsError: null,
        events: action.data && action.data.result ? action.data.result : [],
        totalPages: action.data.totalPages,
      };

    case EVENTS_LOAD_EVENTS_FAILURE:
      return {
        ...state,
        loadEventsPending: false,
        loadEventsError: action.data.error,
      };

    case EVENTS_LOAD_EVENTS_DISMISS_ERROR:
      return {
        ...state,
        loadEventsError: null,
      };

    default:
      return state;
  }
}
